const translations = {
  title: 'Atividades',
  'menu.import': 'Importar',
  'menu.importHistory': 'Histórico de importação',
  'menu.export': 'Exportar',
  'menu.exportHistory': 'Histórico de exportação',
  'menu.unproductives': 'Motivos de Improdutiva',
  'menu.disapproves': 'Motivos de reprovação',
  'menu.canceled': 'Motivos de cancelamento',
  'menu.pendencies': 'Motivos de Pendência',
  'menu.newTrigger': 'Criar automação',
  'menu.triggers': 'Automações',
  'menu.integrations': 'Integrações',
  'menu.fields': 'Customizar campos adicionais',
  'menu.tags': 'Tags de Atividade',
  'menu.templates': 'Templates de PDF',
  'menu.templateHistory': 'Histórico de Documento',
  'counter.text': 'Registros encontrados',
  'menu.publicToken': 'Tokens públicos',
  'menu.semaphore': 'Configuração de farol',
  'menu.sla': 'Configurar SLA',
  'menu.routines': 'Rotinas',
  'menu.configurations.automatic.distribution': 'Configurar distribuição automática',
  'search.normal': 'Busca normal',
  'search.reply': 'Busca por resposta',
  'search.field': 'Busca por campo adicional',
  'search.place': 'Busca por destino',
  'table.code': 'Código',
  'table.responsible': 'Responsável',
  'table.destination': 'Destino',
  'table.scheduling': 'Agendamento',
  'table.completion': 'Conclusão',
  'table.sla': 'SLA',
  'table.status': 'Status',
  'table.priority': 'Prioridade',
  'table.tag': 'Tag',
  'table.openedAt': 'Aberto em',
  'error.unexpected': 'Erro inesperado ao criar atividade'
}

export default translations
